import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import HandleTable from "./HandleTable";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { resumeRequest } from "../TokenProcessing";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Title?: string;
      ViewIdent?: string;
    };
    CLSID?: string;
    Module?: string;
    Title?: string;
    content?: unknown;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const priviewDocument = (data: Data) => {
  const { json, subData, requestID } = data;

  smetaModals.open(
    <HandleTable
      json={{
        ...json,
        CLSID: "{408E20A3-4BE3-4DCD-98BD-2613A8968783}",
      }}
      subData={{
        props: {
          ...subData.props,
          Module: json.Module,
          SectionID: getModalSectionID(),
          func: subData.func,
          from: subData.from,
          CLSID: "{408E20A3-4BE3-4DCD-98BD-2613A8968783}",
          ViewIdent: json?.Params?.ViewIdent || "",
          content: json.content,
          Buttons: -1,
          NoContextMenu: true,
        },
      }}
    />,
    {
      Title: json.Params.Title,
      style: getStyleWindow("{408E20A3-4BE3-4DCD-98BD-2613A8968783}"),
      onClose: () => {
        subData.props?.input?.current?.focus();
        resumeRequest(requestID, subData, {});
      },
      callBacks: true,
    },
  );
};
